import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Link from '@mui/material/Link'


import baseaaimage from  'src/assets/base.png';

const SafeCoreInfo = () => {
  return (
    <div>
      <img src={baseaaimage} alt="baseaaimage" width="800px" />
    </div>
  )
}

export default SafeCoreInfo
